const HIDDEN_FIELD_NAMES = [
    "code",
    "finance_type",
    "offer_type",
    "contract_period",
    "contribution",
    "repurchase",
    "mileage",
];
export function syncHiddenForm(state) {
    var _a;
    const form = document.querySelector(".lead-config-component #config-offer-form");
    if (!form) {
        return;
    }
    const setHidden = (name, value) => {
        let input = form.querySelector(`[name="LeadOfferForm[${name}]"]`);
        if (!input) {
            input = document.createElement("input");
            input.type = "hidden";
            input.name = `LeadOfferForm[${name}]`;
            form.appendChild(input);
        }
        input.value = value;
    };
    setHidden("code", state.code);
    setHidden("user_change", state.user_change);
    setHidden("user_param_change", state.user_param_change);
    for (const name of HIDDEN_FIELD_NAMES) {
        if (name === "code")
            continue;
        setHidden(name, String((_a = state[name]) !== null && _a !== void 0 ? _a : ""));
    }
    form.querySelectorAll('[name^="LeadOfferForm[packages]"]').forEach((el) => el.remove());
    Object.entries(state.packages).forEach(([id, val]) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = `LeadOfferForm[packages][${id}]`;
        input.value = val;
        form.appendChild(input);
    });
}
export function publishPriceResult(response, state) {
    syncHiddenForm(state);
    document.dispatchEvent(new CustomEvent("offer-detail:price", {
        detail: {
            response,
            state,
            isFirstLoad: state.isFirstLoad,
        },
    }));
}
